import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

type DefaultOptions = {
  startLoading?: () => void;
  finishLoading?: () => void;
};
const defaultOptions: DefaultOptions = {};
@Component
export default class UseBackend extends Vue {
  async makeRequest<T>(
    request: () => Promise<T>,
    options: DefaultOptions = defaultOptions
  ): Promise<T> {
    try {
      const startLoading = options.startLoading ?? this.startLoading;
      startLoading();
      return await request();
    } catch (e) {
      // @ts-ignore
      let { data } = e.response;
      if (data) {
        if (data instanceof Blob) {
          data = JSON.parse(await data.text());
        }
        const { detail, error } = data;
        const errorMessage = detail || error;
        if (errorMessage) {
          this.$s.notify.error(errorMessage, { timeout: 2500 });
        }
      }
      throw e;
    } finally {
      const finishLoading = options.finishLoading ?? this.finishLoading;
      finishLoading();
    }
  }

  get makeRequestLoading() {
    return this.$store.state.loading.routeLoading;
  }

  protected finishLoading() {
    this.$s.loading.hide();
  }

  protected startLoading() {
    this.$s.loading.show();
  }
}
